import { cn } from '@/lib/utils';

/**
 * "Still loading", said quietly: three dots that blink one after another, then
 * rest, like the letter S in morse code (· · ·). Pure CSS and the colour of the
 * surrounding text, so it sits in a line of type without drawing the eye.
 *
 * Under reduced motion the dots stop blinking and stay as three faint dots, so
 * the "still working" signal isn't lost.
 */
export function MorseDots({ className, active = true }: { className?: string; active?: boolean }) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-flex shrink-0 items-center gap-[3px] align-middle', className)}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="morse-dot block h-[3px] w-[3px] rounded-full bg-current opacity-30"
          // When `active` is false the work is done: the dots stop blinking and
          // rest as three steady dots.
          style={active ? { animationDelay: `${i * 0.3}s` } : { animation: 'none', opacity: 0.6 }}
        />
      ))}
    </span>
  );
}
